import PortalIdParser from 'PortalIdParser';
export const getSettingsRootUrl = () => `/live-messages-settings/${PortalIdParser.get()}`;